import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { RouterModule } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate/ng2-translate';

import { ENV_PROVIDERS } from './environment';
import { ROUTES } from './app.routes';
import { App } from './app.component';
import { NoContent, Forbidden } from './no-content';
import { UserService, RequestService, AuthGuard, AccessGuard, DcToaster, DcSpinnerService, NotificationService, DcGtmService } from './common/services';
import { ArianMenuService } from './layout/directives/arian-menu.service';
import { DcSpinner } from './common/directives/spinner';
import { LoginGuard } from './login/guard.service';

// AoT requires an exported function for factories
export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, '/assets/i18n', '.json?cache=' + (new Date().getTime()));
}

@NgModule({
  bootstrap: [ App ],
  declarations: [
    App,
    NoContent,
    Forbidden,
    DcSpinner
  ],
  imports: [
    BrowserModule,
    HttpModule,
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }),
    RouterModule.forRoot(ROUTES, { useHash: false })
  ],
  providers: [
    ENV_PROVIDERS,
    LoginGuard,
    TranslateModule,
    UserService,
    RequestService,
    AuthGuard,
    AccessGuard,
    DcSpinnerService,
    DcToaster,
    NotificationService,
    DcGtmService,
    ArianMenuService
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/app.module.ts